import { render, staticRenderFns } from "./Publish.vue?vue&type=template&id=44c7d8c9"
import script from "./Publish.vue?vue&type=script&lang=js"
export * from "./Publish.vue?vue&type=script&lang=js"
import style0 from "./Publish.vue?vue&type=style&index=0&id=44c7d8c9&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports